import React, { useState } from 'react';
import { I18n } from 'react-redux-i18n';
import NewModal from '../new-modal-steps';
import './index.scss';

const POLICY_URL = 'https://www.goodjourney.io/en/gsn-policy';
const PENALTY_SCHEDULE_URL = 'https://www.goodjourney.io/en/gsn-penalty-policy';

const PolicyTheGlobalNetworkItem = ({ onCancel, onConfirm }) => {
  const [acceptPolicy, setAcceptPolicy] = useState(false);

  const handleConfirm = () => {
    if (acceptPolicy) onConfirm?.();
  };

  return (
    <div className="policy-the-global-network">
      <div className="policy-the-global-network__content">
        <h2 className="policy-the-global-network__title">
          {I18n.t('networkSetting.confirmGsnParticipationTitle')}
        </h2>
        <p className="policy-the-global-network__description">
          {I18n.t('networkSetting.confirmGsnDescriptionPart1')}
          <a
            href={POLICY_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="policy-the-global-network__link"
          >
            {I18n.t('networkSetting.gsnPolicy')}
          </a>
          {I18n.t('networkSetting.confirmGsnDescriptionPart2')}
          <a
            href={PENALTY_SCHEDULE_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="policy-the-global-network__link"
          >
            {I18n.t('networkSetting.gsnNetworkPenaltySchedule')}
          </a>
          {I18n.t('networkSetting.confirmGsnDescriptionPart3')}
        </p>
        <label className="policy-the-global-network__checkbox-wrap">
          <input
            type="checkbox"
            checked={acceptPolicy}
            onChange={(e) => setAcceptPolicy(e.target.checked)}
            className="policy-the-global-network__checkbox"
          />
          <span className="policy-the-global-network__checkbox-label">
            {I18n.t('networkSetting.confirmGsnCheckboxLabel')}
          </span>
        </label>
        <div className="policy-the-global-network__actions">
          <button
            type="button"
            className="policy-the-global-network__btn policy-the-global-network__btn--cancel"
            onClick={onCancel}
          >
            {I18n.t('generalSetting.Cancel')}
          </button>
          <button
            type="button"
            className="policy-the-global-network__btn policy-the-global-network__btn--confirm"
            onClick={handleConfirm}
            disabled={!acceptPolicy}
          >
            {I18n.t('networkSetting.confirmAndEnable')}
          </button>
        </div>
      </div>
    </div>
  );
};

const PolicyTheGlobalNetwork = ({ isShow, onClose, onConfirm }) => {
  const handleClose = () => {
    onClose?.();
  };

  const handleConfirm = () => {
    onConfirm?.();
    handleClose();
  };

  return (
    <NewModal
      defaultStep={0}
      customStyle={{ maxWidth: '525px' }}
      open={isShow}
      onClose={handleClose}
      onFinish={handleConfirm}
      hideFooter
      hideCloseButton
      steps={[
        <PolicyTheGlobalNetworkItem
          key="step1"
          onCancel={handleClose}
          onConfirm={handleConfirm}
        />,
      ]}
    />
  );
};

export default PolicyTheGlobalNetwork;
